// Detect if hero contains a description
const hero = {
  heroDescription : () => {
    const hero = document.querySelector('.hero');
    if (hero) {
      const heroDescription = hero.querySelector('.hero__description');
      if (!heroDescription) {
        hero.classList.add('hero--no-description');
      }
    }
  }
}

export default hero;
